<div class="relative">
  <button type="button" class="layout-topbar-action" (click)="op.toggle($event)">
    <i class="pi pi-bell"></i>
    <p-badge
      *ngIf="((unreadCount$ | async) ?? 0) > 0"
      [value]="(unreadCount$ | async) || 0"
      severity="danger"
      size="small"
      class="absolute top-0 right-0 -translate-y-1 translate-x-1 rounded-full">
    </p-badge>
  </button>
  <p-popover #op>
    <sm-notification-hover/>
  </p-popover>
</div>
